<template>
  <div>

    <!-- replace title for this section -->
    <slot name="title" />
    <NewCourseCard v-if="courses" class="mt-5" title="" :courses="getCourses" />
    <b-container>

      <b-row >
        <b-col lg='12' class="text-center">
          <!-- show Pagination if havePagination props is true -->
          <m-pagination-400 class='mt-4 ml-auto mr-auto'
                      v-if="havePagination"
                      :meta="meta"
                      :on-change-page="changePage"
          />

        </b-col>
        <!-- get more Button for this Courses -->
        <slot name="more"></slot>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// TODO: register globally newCourseCard and change Name To standard name
import NewCourseCard from "./newCourseCard";

import { mapGetters } from "vuex";

export default {
  name: "Course",
  components: { NewCourseCard },
  props: ["havePagination","title",'showNumber'],
  computed: {
    ...mapGetters({
      courses: "Course/getCourses",
      meta: "Course/getPaginationMeta",
    }),
    getCourses(){
      if(this.showNumber){
        const course= this.courses;
        return course.slice(0,this.showNumber)
      }else{
        return this.courses
      }
    }
  },
  methods: {
    changePage(page) {
      this.$store.dispatch("Course/setCourses", page);
    },
  },
  async mounted() {
    await this.$store.dispatch("Course/setCourses", 1);
  },
};
</script>